;(() => {
  class PdpStickyInfo extends XThemeBaseElement {
    mount() {
      if (this.dataset.stickyMode !== 'bottom') return

      this.updateStickyOffset = () => {
        const panelHeight = this.getBoundingClientRect().height
        const stickyAtcVisible =
          this.stickyAtc?.classList.contains('is-visible') &&
          window.getComputedStyle(this.stickyAtc).visibility !== 'hidden'
        const stickyAtcHeight = stickyAtcVisible
          ? this.stickyAtc.getBoundingClientRect().height
          : 0
        const bottomGap = 24 + stickyAtcHeight
        const stickyTop = window.innerHeight - panelHeight - bottomGap
        this.style.setProperty('--pdp-info-sticky-top', `${Math.round(stickyTop)}px`)

        const headerHeight = Number.parseFloat(
          window.getComputedStyle(document.documentElement)
            .getPropertyValue('--nt-sticky-header-height'),
        ) || 0
        const topGap = headerHeight + 24
        const availableHeight = window.innerHeight - topGap - bottomGap

        if (panelHeight <= availableHeight) {
          this.classList.remove('is-bottom-stuck')
          this.classList.add('is-short-panel')
          return
        }

        this.classList.remove('is-short-panel')

        const scrollY = window.scrollY
        if (!this.classList.contains('is-bottom-stuck')) {
          this.naturalDocumentTop = this.getBoundingClientRect().top + scrollY
        }

        const activationScroll = Math.max(1, this.naturalDocumentTop - stickyTop)
        const shouldStick = scrollY >= activationScroll
        this.classList.toggle('is-bottom-stuck', shouldStick)

        if (!shouldStick) {
          this.naturalDocumentTop = this.getBoundingClientRect().top + scrollY
        }
      }

      this.stickyAtc = document.querySelector('[data-pdp-sticky-atc]')
      this.updateStickyOffset()
      this.resizeObserver = new ResizeObserver(this.updateStickyOffset)
      this.resizeObserver.observe(this)
      if (this.stickyAtc) {
        this.resizeObserver.observe(this.stickyAtc)
        this.stickyAtcObserver = new MutationObserver(this.updateStickyOffset)
        this.stickyAtcObserver.observe(this.stickyAtc, {
          attributes: true,
          attributeFilter: ['class'],
        })
      }
      window.addEventListener('resize', this.updateStickyOffset, {
        passive: true,
        signal: this._ac.signal,
      })
      window.addEventListener('scroll', this.updateStickyOffset, {
        passive: true,
        signal: this._ac.signal,
      })
      document.fonts?.ready.then(() => {
        if (this._connected) this.updateStickyOffset()
      })
    }

    unmount() {
      this.resizeObserver?.disconnect()
      this.stickyAtcObserver?.disconnect()
      this.resizeObserver = null
      this.stickyAtcObserver = null
      this.stickyAtc = null
    }
  }

  if (!window.customElements.get('x-pdp-sticky-info')) {
    window.customElements.define('x-pdp-sticky-info', PdpStickyInfo)
  }
})();
